import styled from 'styled-components';

export const StyledClipboardInput = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px;
  grid-gap: 30px;
  align-items: center;
  .clipboard-input {
    label {
      font-family: 'Open Sans', sans-serif;
    }
    input {
      font-size: 16px;
    }
    & > div {
      background-color: rgba(229,227,236,0.5);
    }
  }
`;

export const StyledCopyButton = styled.button`
  width: 50px;
  height: 50px;
  color: #909090;
  font-size: 20px;
  outline: none;
  border: 1px solid #E1E1E1;
  background-color: rgba(22, 41, 84, 0.1);
  border-radius: 50%;
  transition: all .3s ease;
  &:hover {
    color: #fff;
    background-color: rgba(22, 41, 84, 0.3);
  }
`;